export default __webpack_public_path__ + "images/3b46dd6b00eb702185b60ce744ef7527.svg";